import { isQuickPicksV2PayoutType } from '../utils/isQuickPicksV2PayoutType';

import { useQuickPicksSettings } from './useQuickPicksSettings';

export const useIsQuickPicksV2 = (): boolean => {
  const { data } = useQuickPicksSettings();
  return isQuickPicksV2PayoutType(data?.payout_multiplier_type);
};
